import { AlertButton, AlertController, AlertInput, LoadingController, MenuController, ModalController, NavController, Platform, PopoverController, ToastButton, ToastController } from '@ionic/angular';
import { HttpService } from '../data/service/http.service';
import { Location } from '@angular/common';
import { AppSettings } from '../configs/app.settings';
import { AuthenticationService } from '../modules/auth-core/data/service/authentication.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { AppComponent } from 'src/app/app.component';
import { PageType } from 'src/app/data/schema/cbs/page';
import { Category } from 'src/app/data/schema/cbs/category';
import { Community } from 'src/app/data/schema/community';
import { BrowserHelper } from './browser.helper';
import { Log } from '../log';

export class ServiceHelper {

    static authSvc: AuthenticationService;
    static get AppSettings() { return AppSettings; }
    static navCtrl: NavController;
    static platform: Platform;
    static popoverCtrl: PopoverController;
    static loadCtrl: LoadingController;
    static alertCtrl: AlertController;
    static toastCtrl: ToastController;
    static httpSvc: HttpService;
    static title: Title;
    static menuCtrl: MenuController;
    static modalCtrl: ModalController;
    static sanitizer: DomSanitizer;
    static location: Location;
    static appComponent: AppComponent;

    // store the routing history, newest should be first
    static routeHistory: string[] = [];

    static setLocation(url: string) {
        ServiceHelper.location.go(url);
    }

    static async displayAlert(title: string, message: string, buttons: (string | AlertButton)[] = ['OK']): Promise<HTMLIonAlertElement> {
        const alert = await ServiceHelper.alertCtrl.create({
            header: title,
            message,
            buttons: buttons,
            cssClass: "custom-alert",
        });
        await alert.present();
        return alert;
    }

    static async displayLoad(message: string) {
        const load = await ServiceHelper.loadCtrl.create({
            message: message
        });
        load.present();
        return load;
    }

    static async displayToast(message: string, duration: number = 2000, buttons: ToastButton[] = [], position: 'top' | 'bottom' | 'middle' = 'top') {
        const toast = await ServiceHelper.toastCtrl.create({ message, position, duration, buttons: buttons });
        await toast?.present();
        return toast;
    }

    static async back(defaultBack: string) {
        // super hacky, lets see if window location changes to know if pop worked...
        const beforeLocation = window.location.href;
        await ServiceHelper.navCtrl.pop()

        if (beforeLocation == window.location.href) {
            // we went nowhere, use default
            ServiceHelper.navCtrl.navigateBack(defaultBack);
        }
    }

    static async confirmSomething(title: string, body: string, cancelLbl: string = 'Cancel', confirmLbl: string = 'Confirm'): Promise<boolean> {
        return new Promise(async (resolve) => {
            // create modal alert
            const confirmationAlert = await this.alertCtrl?.create({
                header: title,
                message: body,
                buttons: [
                    {
                        text: cancelLbl,
                        role: 'cancel',
                        handler: () => resolve(false)
                    },
                    {
                        text: confirmLbl,
                        handler: () => resolve(true)
                    }
                ]
            });
            confirmationAlert?.present();
        });
    }

    static async getValue(title: string, body: string, cancelLbl: string = 'Cancel', confirmLbl: string = 'Confirm', 
        inputType: 'text' | 'number' | 'checkbox' | 'radio' | 'textarea'  = 'text', radioLabels?: string[], radioValues?: number[]) {
        return new Promise(async (resolve) => {

            var inputs: AlertInput[] = [];
            if ( inputType == 'radio' ) {
                for(let i = 0; i < radioLabels.length; i++) {
                    inputs.push({
                        type: 'radio',
                        label: radioLabels[i],
                        value: radioValues[i],
                        checked: false
                      });
                }
            } else {
                inputs.push ({
                    name: 'value',
                    type: inputType, //isNumber ? 'number' : 'text',
                    placeholder: 'Value',
                });
            }
            Log.debug('create alert with inputs: ', inputs)

            // create modal alert
            const confirmationAlert = await this.alertCtrl?.create({
                header: title,
                message: body,
                buttons: [
                    {
                        text: cancelLbl,
                        role: 'cancel',
                        handler: () => resolve(null)
                    },
                    {
                        text: confirmLbl,
                        handler: (data: any) => {
                            Log.debug('confirm alert confirm pressed,  handle data: ', data)
                            resolve(data)
                        }
                    }
                ],
                inputs: inputs
            });
            confirmationAlert?.present();
        });
    }

    static async openSite() {
        if (Community.activeCommunity.homePageId == null) {

            let actionButtons = [
                { text: 'Cancel' },
                { text: 'Configure Home Page', handler: () => { ServiceHelper.navCtrl.navigateForward('/content/home-page') } },
                {
                    text: 'Open Home Page Anyhow', handler: () => {
                        // BrowserHelper.staticOpenUrl(Community.activeCommunity.getFullSiteUrl());
                        BrowserHelper.instance.previewPage();
                    }
                }
            ];
            if (Community.activeCommunity.website != null) {
                actionButtons.push(
                    {
                        text: 'Open External URL', handler: () => {
                            BrowserHelper.staticOpenUrl(Community.activeCommunity.website);
                        }
                    })
            }
            ServiceHelper.displayAlert('No Home Page',
                `You do not have a home page configured within your CommuniBee site so it won\'t load correctly if people
            try to navigate to the site URL directly. <br><br>
            ${Community.activeCommunity.website != null ?
                    'Clicking the header logo is configured to take people to ' + Community.activeCommunity.website + '<br><br>' :
                    ''}
            If not using a CommuniBee home page, you can still open specific pages from the dashboard from their Overview tab. `,
                actionButtons);
        } else {
            // BrowserHelper.staticOpenUrl(Community.activeCommunity.getFullSiteUrl());
            BrowserHelper.instance.previewPage();
        }
    }

    static async getDashBasePath(entity: any) {

        var catId, catGroupId;
        if ([PageType.EventCategory, PageType.MarketplaceCategory, PageType.SponsorCategory,
        PageType.ResourceCategory, PageType.FilterCategory].includes(entity.pgType)) {


            if (entity.category != null && entity.category.categoryId > 0) {
                catId = entity.category.categoryId
                catGroupId = entity.category.categoryGroupId
            } else {
                const cat = await Category.getCatForPage(entity.pageId);
                catId = cat.categoryId;
                catGroupId = cat.categoryGroupId;
            }

        }
        if ([PageType.EventsHome, PageType.MarketplaceHome, PageType.SponsorsHome,
        PageType.ResourcesHome, PageType.FilterHome].includes(entity.pgType)) {

            if (entity.categoryGroup != null && entity.categoryGroup.categoryGroupId > 0) {
                catGroupId = entity.category.categoryGroupId
            } else {
                const catGroup = await Category.getCatGroupForPage(entity.pageId);
                catGroupId = catGroup.categoryGroupId;
            }
        }

        switch (entity.pgType) {
            case PageType.Event: return `/events/event/${entity.event.eventId}`;
            case PageType.EventCategory: return `/events/event-category/${catGroupId}/${catId}`;
            case PageType.EventsHome: return `/events/events-home-page/${catGroupId}`;
            case PageType.Product: return `/marketplace/product/${entity.product.productId}`;
            case PageType.MarketplaceCategory: return `/marketplace/marketplace-category/${catGroupId}/${catId}`;
            case PageType.MarketplaceHome: return `/marketplace/marketplace-home-page/${catGroupId}`;
            case PageType.Resource: return `/marketplace/product/${entity.product.productId}`;
            case PageType.ResourceCategory: return `/content/resource-category/${catGroupId}/${catId}`;
            case PageType.ResourcesHome: return `/content/resources-home-page/${catGroupId}`;
            case PageType.Sponsor: return `/fundraising/sponsor/${entity.sponsor.sponsorId}`;
            case PageType.SponsorCategory: return `/fundraising/sponsor-category/${catGroupId}/${catId}`;
            case PageType.SponsorsHome: return `/fundraising/sponsors-home-page/${catGroupId}`;
            case PageType.FundraisingCampaign: return `/fundraising/campaign/${entity.fundraisingCampaign.fundraisingCampaignId}`;
            case PageType.Donation: return `/fundraising/donation/${entity.product.productId}`;
            case PageType.Post: return `/engagement/post/${entity.pageId}`;
            default: return `/content/page/${entity.pageId}`;
        }
    }
}
